enum UserDoctorTypeEnum {
  DOCTOR = 'Médico(a)',
  EMBRYOLOGIST = 'Embriologista/Andrologista',
  NURSING = 'Enfermagem',
  WELCOMING_TEAM = 'Equipe de Acolhimento',
  OTHERS = 'Outros'
}

export default UserDoctorTypeEnum